import { RightArrowIcon } from "../../../components/common/Icons";
import roster_img from '../portal/roster.png';
import ess_img from '../portal/ess.png';
import manual_img from '../portal/manuals.png';
import notice_img from '../portal/notice.png';
import portal_img from '../portal/portal.png';
import forum_img from '../portal/forum.png';
import ticket_img from '../portal/ticket.png';
import profile_img from '../portal/profile.png';
import learning_img from '../portal/learning.png';
import support_img from '../portal/it-support.png';
import benefits_img from '../portal/benefits.png';
import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { useGetMobileLandingPagesQuery } from "../../../app/services/portal";
import { goToRoaster } from "../../../components/BottomNavigation/BottomNavigation";
import { DefaultSystemBrowserOptions, InAppBrowser, DefaultWebViewOptions } from "@capacitor/inappbrowser";
export const portalLinks = [
    {
        id: 1,
        name: 'Roster',
        link: '',
        icon: roster_img,
        subLinks: []
    },
    {
        id: 2,
        name: 'ESS',
        link: '',
        icon: ess_img,
        subLinks: []
    },
    {
        id: 3,
        name: 'Manuals',
        link: '/profile/manuals',
        icon: manual_img,
        subLinks: []
    },
    {
        id: 4,
        name: 'Notices',
        link: '/profile/notice_board',
        icon: notice_img,
        subLinks: []
    },
    {
        id: 5,
        name: 'Portal',
        link: '',
        icon: portal_img,
        subLinks: [
            {
                id: 1,
                name: 'e-Learning',
                link: '',
                icon: learning_img
            },
            {
                id: 2,
                name: 'IT Support',
                link: '',
                icon: support_img
            },
            {
                id: 3,
                name: 'Benefits',
                link: '',
                icon: benefits_img
            }
        ]
    },
    {
        id: 6,
        name: 'Forum',
        link: '',
        icon: forum_img,
        subLinks: []
    },
    {
        id: 7,
        name: 'Apply Ticket',
        link: '',
        icon: ticket_img,
        subLinks: []
    },
    {
        id: 8,
        name: 'Profile',
        link: '',
        icon: profile_img,
        subLinks: []
    }
]
const PortalLink = () => {

    const [data, setData] = useState<any[]>([]);
    const { data: landingData } = useGetMobileLandingPagesQuery();
    useEffect(() => {
        if (landingData) {
            setData(landingData);
        }
    }, [landingData]);
    const check_link = (link: string, key: string) => {
        if (key === 'manuals') {
            return '/profile/manuals'
        } else if (key === 'notices') {
            return '/profile/notice_board'
        } else if (key === 'profile') {
            return '/profile'
        } else {
            return link;
        }
    }
    const go_link_or_inapp = (key: string) => {
        if (key === 'manuals') {
            return true;
        } else if (key === 'notices') {
            return true;
        } else if (key === 'profile') {
            return true;
        } 
        else if(key==='resources-center'){
            return true;
        }
        else {
            return false;
        }
    }
    const open_with_inapp_browser = async (link: string, key: string) => {
        if (key !== 'manuals' && key !== 'notices' && key !== 'profile') {
            await InAppBrowser.openInSystemBrowser({
                url: link,
                options: DefaultSystemBrowserOptions
            }).then((res) => {
                const url = window.location;
                console.log("res", res, url)
            });
        } else {
            window.location.href = link;
        }

    }
    return <div className="py-4 px-5">
        <ul className="grid grid-cols-2 gap-[10px]">
            {data?.map((link, key) => {
                return <li key={key} className="">
                    {link.key !== "Roaster" ?  go_link_or_inapp(link.key)?
                    <NavLink to={{ pathname: link.subLinks?.length > 0 ? `/home/${link.id}` : check_link(link.link, link.key) }} className="h-full px-3 py-4 bg-sat_lightgray rounded-4 block w-full">
                        <img src={link.logo} alt={link.name} className="w-[30px] mx-auto object-contain aspect-square rounded-[2px]" />
                        <div className="flex mt-[10px] justify-between items-center">
                            <p className="text-button font-bold leading-[normal] text-darkblackv2 text-center w-full max-w-[133px] mx-auto">{link.name}</p>
                            {/* <RightArrowIcon /> */}
                        </div>
                    </NavLink>:
                    <button onClick={() => open_with_inapp_browser(link.link,link)} className="h-full px-3 py-4 bg-sat_lightgray rounded-4 block w-full">
                            <img src={link.logo} alt={link.name} className="w-[30px] mx-auto object-contain aspect-square rounded-[2px]" />
                            <div className="flex mt-[10px] justify-between items-center">
                                <p className="text-button font-bold leading-[normal] text-darkblackv2 text-center w-full max-w-[133px] mx-auto">{link.name}</p>
                                {/* <RightArrowIcon /> */}
                            </div>
                        </button>
                     :
                        <button onClick={() => goToRoaster()} className="h-full px-3 py-4 bg-sat_lightgray rounded-4 block w-full">
                            <img src={link.logo} alt={link.name} className="w-[30px] mx-auto object-contain aspect-square rounded-[2px]" />
                            <div className="flex mt-[10px] justify-between items-center">
                                <p className="text-button font-bold leading-[normal] text-darkblackv2 text-center w-full max-w-[133px] mx-auto">{link.name}</p>
                                {/* <RightArrowIcon /> */}
                            </div>
                        </button>}
                </li>
            })}
        </ul>
    </div>
}
export default PortalLink;